import { ArrowBack } from '@mui/icons-material'
import { Box } from '@mui/material'
import { useQueries } from '@tanstack/react-query'
import DinamicTable from 'components/dinamic-table'
import Loading from 'components/loading'
import WrapperWithHeader from 'components/wrapper-with-header'
import { useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { load, loadItem } from 'services/requests'
import { captalize } from 'utils/captalize'
import { useStyles } from './styles'

interface IRouteWithTableParams {
  id: string
  snowflakeTableId: string
}

interface ISnowFlakeTable {
  label: string
  id: string
  name: string
  records: number
}

interface ITableData {
  data: any[]
  count: number
}

const CofreDigitalTablePreview = () => {
  const [page, setPage] = useState<number>(1)
  const [rowsPerPage, setRowsPerPage] = useState<number>(10)

  const { snowflakeTableId, id } = useParams<IRouteWithTableParams>()

  const classes = useStyles()
  const history = useHistory()

  const [content, snowflake] = useQueries({
    queries: [
      {
        queryKey: ['table', snowflakeTableId, page, rowsPerPage],
        queryFn: () =>
          load('/conducco-cdp-organizations/select-all-data', {
            snowflakeTableId: snowflakeTableId,
            organizationIdOutput: id,
            database: 'dbconducco',
            page: page,
            rowsPerPage: rowsPerPage,
          }),
        enabled: snowflakeTableId != null,
        refetchInterval: 10000,
      },
      {
        queryKey: ['snowflake-tables', snowflakeTableId],
        queryFn: () => loadItem('/snowflake-tables', snowflakeTableId),
        enabled: snowflakeTableId != null,
      },
    ],
  })

  const handleBackPage = () => history.push(`/cofre-digital`)

  let snowFlakeTableData: ISnowFlakeTable = {
    label: '',
    id: '',
    name: '',
    records: 0,
  }

  const loading = snowflake.isPending || content.isPending

  if (loading) {
    return (
      <WrapperWithHeader>
        <Box className={classes.root}>
          <Loading />
        </Box>
      </WrapperWithHeader>
    )
  }

  snowFlakeTableData = (snowflake?.data as any)?.data?.data as ISnowFlakeTable
  const tableData = (content?.data as any)?.data?.data as ITableData

  return (
    <WrapperWithHeader>
      <Box className={classes.root}>
        <Box className={classes.headerContainer}>
          <Box className={classes.headerText}>
            <h1>
              <ArrowBack
                fontSize='small'
                color='primary'
                onClick={handleBackPage}
                sx={{ cursor: 'pointer' }}
              />
              <span> Tabela: </span>
              <span>{captalize(snowFlakeTableData?.label)}</span>
            </h1>
          </Box>
        </Box>

        <DinamicTable
          data={tableData?.data}
          rowsPerPage={rowsPerPage}
          page={page}
          isLoading={snowflake.isPending || content.isPending}
          totalPages={Math.ceil(tableData?.count || 0 / rowsPerPage)}
          handleNextPage={() => setPage(page + 1)}
          handlePrevPage={() => setPage(page - 1)}
          onChangeRowPerPage={(value) => {
            setRowsPerPage(value)
            setPage(1)
          }}
        />
      </Box>
    </WrapperWithHeader>
  )
}

export default CofreDigitalTablePreview
